import React, { memo } from "react";
import PropertyGroup from "./PropertyGroup";

const DailyView = memo(function DailyView({
  propertyNames,
  tasksByProperty,
  propertyNameToIdMap,
  propertyKeyMap,
  handleTaskClick,
  handleToggle,
}) {
  return (
    <>
      {propertyNames.map((propertyName) => {
        const propertyData = tasksByProperty[propertyName];
        const tasks = Array.isArray(propertyData) ? propertyData : [];
        return (
          <PropertyGroup
            key={propertyName}
            propertyName={propertyName}
            tasks={tasks}
            propertyNameToIdMap={propertyNameToIdMap}
            propertyKeyMap={propertyKeyMap}
            handleTaskClick={handleTaskClick}
            handleToggle={handleToggle}
            isWeekly={false}
          />
        );
      })}
    </>
  );
});

export default DailyView;

